import { createSlice } from "@reduxjs/toolkit";

const homeSlice = createSlice({
  name: "home",

  initialState: {
    item_id: null,
    coupon: null,
    utm: null,
    user: null,
    firstUtmParams: null,
    lastUtmParams: null,
    stashToken: null,
  },

  reducers: {
    initialize(state, action) {
      state.item_id = action.payload.item_id;
      state.coupon = action.payload.coupon;
      state.utm = action.payload.utm;
      state.user = action.payload.user;
      state.firstUtmParams = action.payload.firstUtmParams;
      state.lastUtmParams = action.payload.lastUtmParams;
      state.stashToken = action.payload.stashToken;
    },
  },
});

export const homeActions = homeSlice.actions;

export default homeSlice;
